<template>
  <div class="user-register">
    <a class="img_logo">
      <img :src="require('@/assets/bdj-logo.png')" />
    </a>
    <div
      class="user-register-bg"
      :style="{ 'background-image': `url(${backgroundImage})` }"
    ></div>
    <div class="content-wrapper">
      <h2 class="slogan">
        欢迎使用
        <br />
        {{ platformName }}
      </h2>
      <div class="form-container">
        <h4 class="form-title">注册</h4>
        <el-form ref="registerForm" :model="registerForm" label-width="0">
          <div class="form-items">
            <el-row class="form-item">
              <el-col>
                <el-form-item
                  label="邮箱:"
                  hidden-label
                  prop="email"
                  required
                  :rules="{ type: 'email' }"
                >
                  <div class="form-line">
                    <!-- <i class="el-icon-edit-outline input-icon"></i> -->
                    <el-input
                      placeholder="邮箱"
                      v-model="registerForm.email"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="form-item">
              <el-col>
                <el-form-item
                  label="邮箱验证码:"
                  hidden-label
                  prop="emailCaptcha"
                  required
                >
                  <div class="form-line">
                    <!-- <i class="el-icon-edit-outline input-icon"></i> -->
                    <el-input
                      placeholder="请输入邮箱验证码"
                      v-model="registerForm.emailCaptcha"
                    ></el-input>
                    <CVerificationCode :value="registerForm.email" :top="-5" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="form-item">
              <el-col>
                <el-form-item
                  label="登录密码:"
                  prop="password"
                  required
                  hidden-label
                >
                  <div class="form-line">
                    <!-- <i class="el-icon-service input-icon"></i> -->
                    <el-input
                      type="password"
                      placeholder="登录密码"
                      v-model="registerForm.password"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="form-item">
              <el-col>
                <el-form-item
                  label="确认密码:"
                  prop="repetPassword"
                  required
                  hidden-label
                >
                  <div class="form-line">
                    <!-- <i class="el-icon-service input-icon"></i> -->
                    <el-input
                      type="password"
                      placeholder="确认密码"
                      v-model="registerForm.repetPassword"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 用户信息start -->
            <el-row class="form-item">
              <el-col>
                <el-form-item
                  prop="realName"
                  label="姓名:"
                  required
                  hidden-label
                >
                  <div class="form-line">
                    <!-- <i class="el-icon-service input-icon"></i> -->
                    <el-input
                      type="text"
                      placeholder="请输入真实姓名,提交后不可更改"
                      v-model="registerForm.realName"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row class="form-item">
              <el-col>
                <el-form-item
                  prop="idNumber"
                  label="身份证:"
                  required
                  hidden-label
                  :rules="{ type: 'idcard' }"
                >
                  <div class="form-line">
                    <!-- <i class="el-icon-service input-icon"></i> -->
                    <el-input
                      type="text"
                      placeholder="身份证号提交后不可更改,请仔细核对"
                      v-model="registerForm.idNumber"
                    ></el-input>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="form-item">
              <el-col>
                <el-form-item prop="sex" label="性别:" required hidden-label>
                  <div class="form-line sex_box">
                    <!-- <i class="el-icon-service input-icon"></i> -->
                    <el-radio-group v-model="registerForm.sex">
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row class="form-item">
              <el-col>
                <el-form-item prop="password" :rules="[ { required: true, message: '身份证照片'}]">
                    <i class="el-icon-service input-icon"></i>
                    <el-upload
                      class="avatar-uploader"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                    >
                      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon">
                        <span class="tips_text">身份证照片</span>
                      </i>
                    </el-upload>
                </el-form-item>
              </el-col>
            </el-row>-->
            <!-- 用户信息end -->
            <el-row class="form-item">
              <el-button
                type="primary"
                class="submit-btn"
                size="small"
                @click="submitBtn"
                >注 册</el-button
              >
            </el-row>
            <el-row class="form-item read-rule">
              <el-checkbox v-model="haveRead"></el-checkbox>
              <span @click="$_onShowRule">我已同意个人信息收集规则</span>
            </el-row>
          </div>
          <el-row class="tips">
            <a href="#/login" class="link">已有账号?直接登录</a>
          </el-row>
        </el-form>
      </div>
    </div>
    <c-model
      ref="rule"
      title="个人信息收集规则"
      width="80%"
      @confirm="$_onConfirmRule"
    >
      <div class="rule-content">
        <p>
          湖南八斗金人才信息科技有限公司（以下可称为"我们"）深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全可控。您在使用我们的相关服务（以下简称"服务"）并在域名为http://49.235.113.204:8088/#/login的页面填写个人信息前，请您务必仔细阅读本声明。您一旦主动在页面填写您的个人信息并进行提交操作，即意味着您同意我们按照本声明收集、使用、共享您的相关信息。
        </p>
        <p>
          我们严格遵守《中国人民共和国网络安全法》、《关于办理侵犯公民个人信息刑事案件适用法律若干问题的解释》以及《中华人民共和国个人信息保护法》等国家有关法律、行政法规、行政规章、行业标准，认真执行信息安全与隐私保护的相关管理规定，所收集的个人信息仅用于招聘工作，不从事任何侵犯个人信息和商业秘密的活动。
        </p>
        <h4>一、个人信息的收集</h4>
        <div>
          <p>我们提供服务时，可能会收集下列与您有关的个人信息：</p>
          <p>
            您在本页面所涉及的表单中输入/选择的信息包括但不限于：姓名、性别、出生年月、籍贯、所在地、户口所在地、联系电话、身份证号码、其他联系人姓名、其他联系人联系方式、学历情况、婚姻情况、有无驾照情况、职称/职业资格获取情况、开始工作时间、工作年限、工作经历、项目经历、家庭成员及主要社会关系。
          </p>
          <p>
            您需要注意的是，以上个人信息均是您自愿提供。您有权拒绝提供，但可能无法正常使用相应的服务、功能，无法完成招聘报名。
          </p>
          <p>
            对于所提供的其他人员的相关信息，请您先获取相应人员的同意或授权，一旦您提交了相关人员的信息，我们视为您已经获得了授权。如后续我们在招聘过程中出现相关人员
          </p>
          <p>
            不满 18
            岁的用户，须在其监护人陪同已经阅读和理解本声明并且许可的情况下向我们提交相关个人信息。
          </p>
        </div>
        <h4>二、个人信息的使用</h4>
        <div>
          <p>1.您同意，我们可以通过以下方式对个人信息进行使用：</p>
          <p>（1）拨打手机号码用于及时与您取得联系，与您沟通招聘或相关事宜；</p>
          <p>
            （2）拨打手机号码，进行调研、回访、定期或不定期向您发送招聘信息。
          </p>
          <p>
            2.我们将严格按照国家法律法规及监管要求，除非获得您的授权，否则不会将您的个人信息进行披露、转让、出售、许可或以其他方式提供给任何第三方使用。
          </p>
          <p>
            3.为了保障您的信息安全，我们将按照行业通行标准、努力采取合理的物理、电子和管理方面的安全措施来保护用户的信息，并尽最大合理努力使用户的信息不会被泄漏、毁损或者丢失
          </p>
        </div>
        <h4>三、适用法律与更正、修改、删除</h4>
        <div>
          <p>1.本声明适用中华人民共和国法律。</p>
          <p>
            2.如果您需要查询、修改或更正您的个人信息，如您拟撤回授权/删除您提交的个人信息的，或对个人信息保护问题有任何疑问或投诉，您可以通过0731-86451134与我们联系，我们将尽快配合处理。
          </p>
        </div>

        <h4>四、变更</h4>
        <div>
          <p>
            我们会适时对本声明进行修订，该等修订构成本声明的一部分。我们会将修改后的声明予以发布。在该种情况下，若您继续使用我们的服务，即表示同意接受经修订的声明的约束。
          </p>
        </div>
      </div>
    </c-model>
  </div>
</template>

<script>
const backgroundImage = "/static/images/login-bg.jpg";
import { platformName } from "@/config/GlobalText";
import { storageUtil } from "@/utils";
import { userRes } from "@/api";
import { CVerificationCode } from "@/components/C-VerificationCode";
export default {
  name: "UserRegister",
  data() {
    return {
      platformName,
      backgroundImage: backgroundImage,
      registerForm: {
        email: "",
        emailCaptcha: "",
        idNumber: "",
        password: "",
        realName: "",
        repetPassword: "",
        sex: 1,
      },
      imageUrl: "",
      haveRead: false,
    };
  },
  created() {},
  methods: {
    submitBtn() {
      console.log(this.$refs["registerForm"]);
      this.$refs["registerForm"].validate((valid, info) => {
        if (valid) {
          if (!this.haveRead) {
            this.$message.error("请阅读并同意'个人信息收集规则'!");
            return;
          }
          userRes.register(this.registerForm).then((res) => {
            this.$confirm("您已注册成功, 是否立即登录?", "提示", {
              confirmButtonText: "前往登录",
              cancelButtonText: "",
              showCancelButton: false,
              type: "success",
            }).then(() => {
              this.$router.push("/login");
            });
          });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    $_onShowRule() {
      this.$refs.rule.open();
    },
    $_onConfirmRule() {
      this.$refs.rule.close();
    },
  },
};
</script>

<style lang="scss">
.user-register {
  :global {
    .el-input__inner {
      border: none;
    }
  }
  .el-form-item__error {
    padding-left: 10px;
  }
  .user-register-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: #0a0a0a63;
    }
  }
  .el-checkbox__label {
    color: #999;
    font-size: 13px;
  }
  .content-wrapper {
    position: absolute;
    top: -100px;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 1080px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .slogan {
      text-align: center;
      color: #fff;
      font-size: 36px;
      letter-spacing: 2px;
      line-height: 48px;
      float: left\0;
      position: absolute\0;
      left: 0\0;
      top: 35%\0;
    }
  }
  .form-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 30px 40px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 1px 1px 2px #eee;
    float: right\0;
    position: absolute\0;
    right: 0\0;
    top: 18%\0;
  }
  .el-form-item {
    margin-bottom: 23px;
  }
  .form-Item {
    position: relative;
    flex-direction: column;
  }
  .form-line {
    position: relative;
    display: flex;
    align-items: center;
    &:after {
      content: "";
      position: absolute;
      bottom: 3px;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-color: #dcdcdc;
      border-radius: 0;
    }
  }
  .el-input {
    width: 240px;
    input {
      border: none;
      margin: 0;
      padding-left: 10px;
      font-size: 13px;
    }
  }
  .form-title {
    margin: 0 0 20px;
    text-align: center;
    color: #3080fe;
    letter-spacing: 12px;
  }
  .input-icon {
    color: #999;
  }
  .checkbox {
    margin-left: 5px;
  }
  .submit-btn {
    margin-bottom: 6px;
    width: 100%;
    background: #3080fe;
    border-radius: 28px;
  }
  .tips {
    text-align: center;
  }
  .link {
    // color: #999;
    color: $main_color;
    text-decoration: none;
    font-size: 13px;
  }
  .line {
    color: #dcd6d6;
    margin: 0 8px;
  }
  .el-radio-group {
    display: block;
    width: 100%;
    top: 12px;
    left: 10px;
    position: relative;
  }
  .read-rule {
    color: #666;
    text-align: center;
    margin: 10px 0;
    font-size: 14px;
    span {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .rule-content {
    line-height: 25px;
    p {
      text-indent: 31px;
    }
    h4 {
    }
    div {
      padding-left: 30px;
      p {
        text-indent: initial;
      }
    }
  }
}

@media screen and (max-width: 720px) {
  .user-register {
    .content-wrapper {
      margin: 20px auto;
      top: 40px;
      max-width: 300px;
      display: block;
      .slogan {
        color: #666;
        font-size: 22px;
        line-height: 30px;
      }
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-left: 20px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 90px;
  height: 90px;
  //   line-height: 90px;
  text-align: center;
  padding-top: 18px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.sex_box {
  padding-bottom: 25px;

  .input-icon {
    position: relative;
    top: 12px;
  }
}
.tips_text {
  font-size: 12px;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  top: 49px;
}
</style>
